var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{attrs:{"data-app":""}},[_c('a',{attrs:{"href":"#"},on:{"click":_vm.show}},[_vm._v(_vm._s(_vm.getLocale()))])])}
var staticRenderFns = []

export { render, staticRenderFns }